
import { Clock } from "lucide-react";
import { Card } from "@/components/ui/card";

const ComingSoonPanel = () => {
  const comingSoonFeatures = [
    "Coding playground for ML / AI coding questions",
    "Cheatsheets on ML theory fundamentals",
    "1:1 mentorship with Faang ML coaches"
  ];

  return (
    <div className="space-y-6">
      <Card className="p-6 border-dashed border-2 border-amber-300 bg-amber-50/50">
        <div className="flex items-center gap-2 mb-4">
          <Clock className="h-5 w-5 text-amber-500" />
          <h3 className="font-bold text-lg text-amber-700">Coming Soon</h3>
        </div>
        
        <p className="text-muted-foreground mb-4">
          We're working on exciting new features to help you ace your ML interviews:
        </p>
        
        <ul className="space-y-3">
          {comingSoonFeatures.map((feature, index) => (
            <li key={index} className="flex items-start gap-3">
              <div className="w-5 h-5 rounded-full bg-amber-100 text-amber-600 flex items-center justify-center flex-shrink-0 mt-0.5">
                {index + 1}
              </div>
              <span className="text-amber-800">{feature}</span>
            </li>
          ))}
        </ul>
        
        <div className="mt-6 pt-4 border-t border-amber-200">
          <p className="text-sm text-amber-600 font-medium">
            Subscribe now to get early access when these features launch!
          </p>
        </div>
      </Card>
    </div>
  );
};

export default ComingSoonPanel;
